import React, { useState } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { updateJobStatus } from "../../../redux/features/careerSlice";

// job_status: 0 draft, 1 published, 3 closed, 2 deleted(soft)
// A clear inline dropdown to change a job's status right from the list.
const STATUS_OPTIONS = [
  { value: 0, label: "Draft" },
  { value: 1, label: "Published" },
  { value: 3, label: "Closed" },
  { value: 2, label: "Delete", danger: true },
];

const JobStatusActions = ({ job, onDone }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const current = Number(job.job_status);
  const [saving, setSaving] = useState(false); // disable the dropdown while the API is in flight

  const handleChange = (e) => {
    const to = Number(e.target.value);
    if (to === current) return;
    setSaving(true);
    dispatch(updateJobStatus({ jobId: job.career_job_id, job_status: to }))
      .then((res) => {
        if (res.payload?.status === "success") {
          enqueueSnackbar(to === 2 ? "Job deleted" : "Job status updated", { variant: "success" });
          onDone && onDone();
        } else {
          enqueueSnackbar(res.payload?.message || "Failed to update status", { variant: "error" });
        }
      })
      .finally(() => setSaving(false));
  };

  return (
    <FormControl
      size="small"
      fullWidth
      disabled={saving}
      onClick={(e) => e.stopPropagation()}
      sx={{ minWidth: 120 }}
    >
      <Select
        value={current}
        onChange={handleChange}
        // while the API is in flight, show a clear "working" label instead of the value
        renderValue={(val) =>
          saving ? "Updating…" : STATUS_OPTIONS.find((o) => o.value === Number(val))?.label
        }
      >
        {STATUS_OPTIONS.map((o) => (
          <MenuItem key={o.value} value={o.value} sx={o.danger ? { color: "error.main" } : undefined}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default JobStatusActions;
